import type { ExcalidrawProps, UIAppState } from "../types";

const LibraryMenuBrowseButton = (_props: {
  libraryReturnUrl?: ExcalidrawProps["libraryReturnUrl"];
  theme?: UIAppState["theme"];
  id?: string;
}) => {
  return null;
};

export default LibraryMenuBrowseButton;
